SupportGetawaysMarketRateStatusAndNotesPresentation =
	confirmed:
		status: "Booked"
		notes:  "Your reservation had been confirmed, but you can double-check by giving the merchant a call at the phone number in your order details."
	used:
		status: "Reservation has passed"
		notes: ""
	cancelled:
		status: "Cancelled"
		notes: "Your 5% Groupon Bucks credit has also been cancelled."

module.exports = SupportGetawaysMarketRateStatusAndNotesPresentation
